import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconGoogle = t0 => {
  const $ = _c(11);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g clipPath="url(#Icon_Google_svg__a)"><path fill="currentColor" d="M63.813 28.453a2.03 2.03 0 0 0-2-1.786H34a2.027 2.027 0 0 0-2 2V38a2.027 2.027 0 0 0 2 2h14.88A18.667 18.667 0 1 1 32 13.333a18.67 18.67 0 0 1 11.28 3.787 1.974 1.974 0 0 0 2.667-.187l6.586-6.64a2 2 0 0 0 .587-1.52 2.05 2.05 0 0 0-.72-1.44A32 32 0 1 0 64 32a32 32 0 0 0-.187-3.547" /></g>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <defs><clipPath id="Icon_Google_svg__a"><path fill="currentColor" d="M0 0h64v64H0z" /></clipPath></defs>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props || $[8] !== t1 || $[9] !== t2) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}{t4}</svg>;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
IconGoogle.displayName = 'IconGoogle';